import React from 'react';
import PropTypes from 'prop-types';

const FormatCryptoAmount = ({ 
  amount, 
  symbol,
  locale = 'en-GB',
  minimumFractionDigits = 0,
  maximumFractionDigits = 8,
  showSymbol = true
}) => {
  const formatValue = () => {
    if (amount === null || amount === undefined || isNaN(amount)) {
      return '0';
    }

    const numAmount = parseFloat(amount);

    try {
      // Use Intl.NumberFormat for consistent decimal formatting
      const formattedNumber = new Intl.NumberFormat(locale, {
        minimumFractionDigits: minimumFractionDigits,
        maximumFractionDigits: maximumFractionDigits
      }).format(numAmount);

      return showSymbol ? `${formattedNumber} ${symbol}` : formattedNumber;
    } catch (error) {
      // Fallback to basic formatting if Intl is not supported
      console.warn('Intl formatting failed, using fallback:', error);
      const formattedNumber = numAmount.toFixed(maximumFractionDigits);
      return showSymbol ? `${formattedNumber} ${symbol}` : formattedNumber;
    }
  };

  return <span>{formatValue()}</span>;
};

FormatCryptoAmount.propTypes = {
  amount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  symbol: PropTypes.string.isRequired,
  locale: PropTypes.string,
  minimumFractionDigits: PropTypes.number,
  maximumFractionDigits: PropTypes.number,
  showSymbol: PropTypes.bool
};

export default FormatCryptoAmount; 
